import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card";
import Spinner from "../../../components/ui/spinner";
import { getUsersRange } from "../../../services/apiservices/support";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const UserGrowthCard = ({ timeRange }) => {
  const [monthlyData, setMontlyData] = useState();
  const [loading, setLoading] = useState(true);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  useEffect(() => {
    setMontlyData();
    setLoading(true);
    getUsersRange(timeRange, "all", true).then((data) => {
      const growthData = months?.map((m) => ({
        month: m,
        users: data[m] || 0,
      }));
      setMontlyData(growthData);
      setLoading(false);
    });
  }, [timeRange]);

  return (
    <Card className="bg-white dark:bg-[#2c3440] p-24">
      <CardHeader className="p-24">
        <CardTitle>User Growth</CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <Spinner size="lg" />
        ) : (
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={monthlyData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="users"
                stroke="#8884d8"
                strokeWidth={2}
              />
            </LineChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
};

export default UserGrowthCard;
